import Button from '@ixigo/iui/Button';
import { Skeleton, SpinningLoaderContent } from '@repo/shared/components';
import { Loader as LoaderIcon } from '@repo/shared/icons';
import { Fragment } from 'react/jsx-runtime';
import { NavigationHeader } from '@/components';

const LoaderItem = () => {
	return (
		<div className="py-10 flex items-center gap-2.5">
			<Skeleton
				loading={true}
				variant="circular"
				level="inherit"
				height={24}
				width={24}
				className="shrink-0"
			/>
			<Skeleton
				loading={true}
				variant="text"
				level="body-md"
				height={16}
				className="w-full"
			/>
		</div>
	);
};

const BaseLoader = ({
	onClose,
	children,
}: {
	onClose: () => void;
	children: React.ReactNode;
}) => {
	return (
		<Fragment>
			<NavigationHeader
				title="Reason for Cancellation"
				leftAction={onClose}
				className="border-b border-tertiary"
			/>
			{children}
			<div className="bg-primary border-t border-tertiary px-20 py-2.5">
				<Button
					onClick={() => {}}
					className="w-full pointer-events-none"
					size="lg"
				>
					<LoaderIcon className="size-4" />
				</Button>
			</div>
		</Fragment>
	);
};

export const CancellationDetailLoader = ({
	onClose,
}: {
	onClose: () => void;
}) => {
	return (
		<BaseLoader onClose={onClose}>
			<div className="space-y-2 px-20 py-15">
				{Array.from({ length: 3 }).map((_, index) => (
					<LoaderItem key={index} />
				))}
			</div>
		</BaseLoader>
	);
};

export const SubmissionLoader = () => {
	return (
		<SpinningLoaderContent
			descriptions={[
				'Initiating your cancellation request...',
				'Please wait while we process your request',
			]}
			className="relative flex flex-col justify-center items-center min-h-300px"
		/>
	);
};
